import voyageArrivalWindowDataFromJson from "../arrival_window/db/mapper";
import voyageConstraintsDataFromJson from "../constraints/db/mapper";
import VoyageOptionsData from "../data";
import voyageFuelDataFromJson from "../fuel/db/mapper";
import voyageTweaksDataFromJson from "../tweaks/db/mapper";
import voyageValidatorDataFromJson from "../validator/db/mapper";

export default function voyageOptionsFromJson(json) {
  return new VoyageOptionsData(
    {
      id: json.id,
      maxServiceSpeed: json.max_service_speed,
      minServiceSpeed: json.min_service_speed,
      maxCruiseSpeed: json.max_cruise_speed,
      minCruiseSpeed: json.min_cruise_speed,
      maxServicePower: json.max_service_power,
      minServicePower: json.min_service_power,
      maxServiceRpm: json.max_service_rpm,
      minServiceRpm: json.min_service_rpm,
      vesselDraft: json.vessel_draft,
      etdWindow: json.etd_window,
      navigationMode: json.navigation_mode,
      useTss: json.use_tss,
      useEca: json.use_eca,
      useTrs: json.use_trs,
      useSuez: json.use_suez,
      usePanama: json.use_panama,
      useKiel: json.use_kiel,
      useTaiwanStrait: json.use_taiwan_strait,
      avoidPiracy: json.avoid_piracy,
      useDatasets: json.use_datasets,
      keepVoyageData: json.keep_voyage_data,
      landProximity: json.land_proximity,
      dailyRate: json.daily_rate,
      operationalMode: json.operational_mode,
      fuel: json.fuel.map((fuel) => voyageFuelDataFromJson(fuel)),
      constraints:
                json.constraints != null && json.constraints != undefined
                  ? voyageConstraintsDataFromJson(json.constraints)
                  : null,
      validator:
                json.validator != null && json.validator != undefined
                  ? voyageValidatorDataFromJson(json.validator)
                  : null,
      tweaks:
                json.tweaks != null && json.tweaks != undefined
                  ? voyageTweaksDataFromJson(json.tweaks)
                  : null,
      arrivalWindow:
                json.arrival_window != null && json.arrival_window != undefined
                  ? voyageArrivalWindowDataFromJson(json.arrival_window)
                  : null,
    }
  );
}
